import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ImageCdnSrcDirective } from '@polaris-customerweb/sharedcomponents.shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BehaviorSubject, combineLatest, takeWhile } from 'rxjs';
import { AppState } from 'src/app/models/app-state';
import { RideTypeService } from 'src/app/services/ride-type.service';
import { selectIsShowingSatellite } from 'src/app/state/map/layer-visibility/layer-visibility.reducer';

export enum MapToolsLayerGroup {
    Fuel,
    PlannedRides,
    TrackedRides,
    InProgressRide,
    Waypoint,
    Dealer,
    Adventure,
    Radar,
    Land,
    Satellite,
    CloudCover,
    SnowDepth,
    RideConditions,
    SnowRideConditions,
    OffRoadRideConditions,
    Areas,
    Food,
    Gas,
    Lodging,
    Unknown,
    Trails,
    TrailDifficulty,
    Heatmap,
}

@Component({
    imports: [AngularSvgIconModule, ImageCdnSrcDirective],
    selector: 'rdx-map-tools-selected-group-summary',
    styleUrls: ['./map-tools-selected-group-summary.component.scss'],
    templateUrl: './map-tools-selected-group-summary.component.html',
})
export class MapToolsSelectedGroupSummaryComponent
    implements OnInit, OnDestroy
{
    @Input() isLayersGroup: boolean;
    @Input() limit = 0;
    @Input() brand = '';

    visibleItem: Record<string, boolean> = {};

    isDestroyed = false;
    isSnow = false;
    isSatellite = false;
    private _selectedItems = new BehaviorSubject<
        {
            key: MapToolsLayerGroup;
            value: boolean;
        }[]
    >([]);

    constructor(
        private store: Store<AppState>,
        private rideTypeService: RideTypeService
    ) {}

    @Input()
    set selectedItems(
        value: {
            key: MapToolsLayerGroup;
            value: boolean;
        }[]
    ) {
        this._selectedItems.next(value);
    }

    get selectedItems() {
        return this._selectedItems.getValue().filter((data) => data.value);
    }

    ngOnInit(): void {
        this.updateDisplayItemListener();
        combineLatest([
            this.store.select(selectIsShowingSatellite),
            this.rideTypeService.isSnoRideType$,
        ])
            .pipe(takeWhile(() => !this.isDestroyed))
            .subscribe(([isSat, isSnow]) => {
                this.isSnow = isSnow;
                this.isSatellite = isSat;
            });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
        this._selectedItems.next([]);
        this._selectedItems.complete();
    }

    private updateDisplayItemListener(): void {
        this._selectedItems.subscribe((item) => {
            const cloneVisibleItems = Object.assign([], this.visibleItem);
            item.filter((x) => !x.value).map(
                (itemValue) =>
                    // eslint-disable-next-line @typescript-eslint/no-array-delete, @typescript-eslint/no-dynamic-delete
                    delete cloneVisibleItems[MapToolsLayerGroup[itemValue.key]]
            );

            item.filter((x) => x.value).map((x) => {
                if (Object.keys(cloneVisibleItems).length < this.limit) {
                    cloneVisibleItems[MapToolsLayerGroup[x.key]] = x.value;
                }
            });

            this.visibleItem = cloneVisibleItems;
        });
    }
}
